require('./page-modules')
require('./owl.carousel')
require('./template')
import '../styles/sass/style.scss'
